<template>
  <div class="summary">
    <div class="summary-card">

      <div class="summary-top-row" v-if="getBetSystemParts && getBetSystemParts.length">
        <div class="summary-title evidence">
          {{ $t('system') || 'Sistema' }}
        </div>
        <div class="summary-odds-container" v-if="getSettings.sys_combinations">
          <span class="odds-label">{{ $t('combinations') || 'Combinaciones' }}</span>
          <span class="odds-value">{{ getBet._system_detail.combinations }}</span>
        </div>
      </div>

      <div class="global-amounts-container">
        <div class="global-amount-row">
          <span class="global-amount-label evidence">{{ $t('amount') }} {{ $t('all') }} {{ getSettings.currencySymbol }}</span>
          <div class="input-group global-input-group">
            <button class="btn-stepper" @click.stop="stepGlobal('equal', -1)">−</button>
            <input
                v-if="!isMobile"
                v-model.number="amountSystemEqual"
                type="number"
                step="0.50"
                inputmode="decimal"
                autocomplete="off"
                class="amount-input"
                @focus="$event.target.select()"
                @blur="onNativeBlurGlobal('equal')"
            />
            <input
                v-else
                :readonly="useVirtualKeyboard"
                :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                :value="amountSystemEqual || 0"
                autocomplete="off"
                class="amount-input"
                :class="{ 'text-selected': activeGlobalField === 'equal' && showCustomKeyboard }"
                @click.stop="useVirtualKeyboard ? openKeyboardGlobal('equal') : null"
                @focus="useVirtualKeyboard ? openKeyboardGlobal('equal') : null"
                @input="useVirtualKeyboard ? null : onNativeInputGlobal('equal', $event)"
                @blur="useVirtualKeyboard ? null : onNativeBlurGlobal('equal')"
            />
            <button class="step-btn" @click.stop="stepGlobal('equal', 1)">+</button>
          </div>
        </div>
        <div class="global-amount-row">
          <span class="global-amount-label evidence">{{ $t('amount') }} {{ $t('divide') }} {{ getSettings.currencySymbol }}</span>
          <div class="input-group global-input-group">
            <button class="btn-stepper" @click.stop="stepGlobal('divide', -1)">−</button>
            <input
                v-if="!isMobile"
                v-model.number="amountSystemToDivide"
                type="number"
                step="0.50"
                inputmode="decimal"
                autocomplete="off"
                class="amount-input"
                @focus="$event.target.select()"
                @blur="onNativeBlurGlobal('divide')"
            />
            <input
                v-else
                :readonly="useVirtualKeyboard"
                :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                :value="amountSystemToDivide || 0"
                autocomplete="off"
                class="amount-input"
                :class="{ 'text-selected': activeGlobalField === 'divide' && showCustomKeyboard }"
                @click.stop="useVirtualKeyboard ? openKeyboardGlobal('divide') : null"
                @focus="useVirtualKeyboard ? openKeyboardGlobal('divide') : null"
                @input="useVirtualKeyboard ? null : onNativeInputGlobal('divide', $event)"
                @blur="useVirtualKeyboard ? null : onNativeBlurGlobal('divide')"
            />
            <button class="step-btn" @click.stop="stepGlobal('divide', 1)">+</button>
          </div>
        </div>
      </div>

      <div class="combo-header-row" v-if="getBetSystemParts && getBetSystemParts.length">
        <label class="combo-check-label" @click.stop>
          <input
              type="checkbox"
              class="combo-checkbox"
              v-model="checkedAll"
              :disabled="getBet._system_detail.valid_combinations_all == 0"
              @change="checkAllComboSystem()"
          />
          <span class="combo-check-custom"></span>
          <span class="combo-check-text">{{ $t('all') }}</span>
        </label>
      </div>

      <div class="combo_container">
        <div
            class="item-combo"
            v-for="combo in getBetSystemParts"
            :key="'combo-' + combo.multiplicity" v-if="combo.valid_combinations > 0"
            :class="{ 'is-open': combo.show, 'is-checked': combo.checked }"
            @click="showDetailCombo(combo)"
        >
          <div class="combo-row-main">
            <div class="combo-row-header">
              <label class="combo-check-label" @click.stop>
                <input
                    type="checkbox"
                    class="combo-checkbox"
                    v-model="combo.checked"
                    :disabled="combo.valid_combinations == 0"
                    @change="onComboCheckChange(combo)"
                />
                <span class="combo-check-custom"></span>
              </label>

              <span class="combo-title" v-if="combo.multiplicity <= 5">
                {{ $t('multi-' + combo.multiplicity) }}
              </span>
              <span class="combo-title" v-else>
                {{ combo.multiplicity }}{{ $t('-multi') }}
              </span>

            </div>

            <div class="combo-actions" @click.stop>
              <div class="input-group">
                <div class="combo-multiplier">
                  {{ combo.valid_combinations }}x
                </div>

                <button class="btn-stepper" @click.stop="stepCombo(combo, -1)" :disabled="combo.valid_combinations == 0">−</button>

                <input
                    v-if="!isMobile"
                    :disabled="combo.valid_combinations == 0"
                    v-model.number="combo.amount"
                    type="number"
                    step="0.10"
                    inputmode="decimal"
                    autocomplete="off"
                    class="amount-input"
                    @focus="$event.target.select()"
                    @change="refreshSystemCart(combo)"
                    @blur="refreshSystemCart(combo)"
                />
                <input
                    v-else
                    :disabled="combo.valid_combinations == 0"
                    :readonly="useVirtualKeyboard"
                    :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                    :value="combo.amount || 0"
                    autocomplete="off"
                    class="amount-input"
                    :class="{ 'text-selected': activeCombo === combo && showCustomKeyboard }"
                    @click.stop="useVirtualKeyboard ? openKeyboard(combo) : null"
                    @focus="useVirtualKeyboard ? openKeyboard(combo) : null"
                    @input="useVirtualKeyboard ? null : onNativeInputCombo(combo, $event)"
                    @blur="useVirtualKeyboard ? null : onNativeBlurCombo(combo)"
                />

                <button class="step-btn" @click.stop="stepCombo(combo, 1)" :disabled="combo.valid_combinations == 0">+</button>
              </div>

              <div class="chevron-wrapper" @click="showDetailCombo(combo)">
                <span class="combo-chevron" :class="{ 'combo-chevron--open': combo.show }"></span>
              </div>
            </div>
          </div>

          <div class="combo-accordion-wrapper" :class="{ 'combo-accordion-wrapper--open': combo.show }">
            <div class="detail-system">
              <div class="detail-col">
                <span class="detail-label">{{ $t('amount') }}</span>
                <span class="detail-val">{{ getSettings.currencySymbol }}{{ combo.totalAmount | round_digits(2) }}</span>
              </div>
              <div class="detail-col">
                <span class="detail-label">{{ $t('win') }} {{ $t('min') }}</span>
                <span class="detail-val">{{ getSettings.currencySymbol }}{{ combo.winning_min | round_digits(2) }}</span>
              </div>
              <div class="detail-col">
                <span class="detail-label">{{ $t('win') }} {{ $t('max') }}</span>
                <span class="detail-val">{{ getSettings.currencySymbol }}{{ combo.winning_all | round_digits(2) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="keyboard-accordion-wrapper" :class="{ 'keyboard-open': showCustomKeyboard && isMobile && useVirtualKeyboard }">
        <div v-if="isMobile" class="custom-keyboard-accordion" @mousedown.prevent>
          <div class="keyboard-row">
            <button v-for="n in [1,2,3,4,5,6,7,8,9]" :key="'kb_'+n" @click="pressKey(n)">{{n}}</button>
            <button @click="pressKey(0)">0</button>
          </div>
          <div class="keyboard-row">
            <button @click="pressKey('.')">.</button>
            <button @click="backspace">⌫</button>
            <button class="close-keyboard" @click="showCustomKeyboard = false">{{ $t('close') }}</button>
          </div>
        </div>
      </div>

      <div class="extra-info-container" ref="infoBet" v-if="hasExtraInfo">
        <div class="extra-info-row" v-if="getSettings.sys_amount_total">
          <span class="info-label">{{ $t('amount') }} {{ $t('total') }} {{ $t('system') }}</span>
          <span class="info-value">{{ getBet._system_detail.amount_system | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>

        <div class="extra-info-row" v-if="getSettings.sys_winning_min">
          <span class="info-label">{{ $t('winning') }} {{ $t('min') }}</span>
          <span class="info-value">{{ getBet._system_detail.winning_min | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sys_winning_max">
          <span class="info-label">{{ $t('winning') }} {{ $t('max') }}</span>
          <span class="info-value">{{ getBet._system_detail.winning_max | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>

        <div class="extra-info-row" v-if="getSettings.sys_bonus_min && +getBet._system_detail.bonus_min > 0">
          <span class="info-label">{{ $t('bonus') }} {{ $t('min') }}</span>
          <span class="info-value">{{ getBet._system_detail.bonus_min | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sys_bonus_max && +getBet._system_detail.bonus_max > 0">
          <span class="info-label">{{ $t('bonus') }} {{ $t('max') }}</span>
          <span class="info-value">{{ getBet._system_detail.bonus_max | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>

        <div class="extra-info-row" v-if="getSettings.sys_winning_total_min">
          <span class="info-label">{{ $t('winning') }} {{ $t('total') }} {{ $t('min') }}</span>
          <span class="info-value">{{ getBet._system_detail.winning_total_min | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sys_winning_total_max">
          <span class="info-label">{{ $t('winning') }} {{ $t('total') }} {{ $t('max') }}</span>
          <span class="info-value">{{ getBet._system_detail.winning_total_max | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sys_winning_all_total">
          <span class="info-label">{{ $t('winning') }} {{ $t('all') }} {{ $t('total') }}</span>
          <span class="info-value">{{ getBet._system_detail.winning_all_total | round_digits(2) }} {{ getSettings.currency }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'SummarySystem',
  data: () => ({
    checkedAll: false,
    showCustomKeyboard: false,
    activeCombo: null,
    activeGlobalField: null,
    previousAmount: null,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
  }),
  mounted() {
    this.$root.$on('forceUpdateSystemV3', () => {
      this.setCheckedAll();
      this.forceUpdateSummarySystem();
    });
    window.addEventListener('resize', this.updateWindowWidth);
    setTimeout(() => {
      this.setCheckedAll();
      this.forceUpdateSummarySystem();
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getBetSystemParts: 'cart/getBetSystemParts',
      getSettings: 'cart/getSettings',
      getMobileKeypadType: 'settings/getMobileKeypadType',
    }),
    isMobile() {
      return this.windowWidth <= 768;
    },
    useVirtualKeyboard() {
      return this.getMobileKeypadType !== 'native';
    },
    hasExtraInfo() {
      return this.getSettings.sys_amount_total ||
          this.getSettings.sys_winning_min ||
          this.getSettings.sys_winning_max ||
          (this.getSettings.sys_bonus_min && +this.getBet._system_detail.bonus_min > 0) ||
          (this.getSettings.sys_bonus_max && +this.getBet._system_detail.bonus_max > 0) ||
          this.getSettings.sys_winning_total_min ||
          this.getSettings.sys_winning_total_max ||
          this.getSettings.sys_winning_all_total;
    },
    amountSystemEqual: {
      get() {
        return this.$store.state.cart.bet._system_detail.amount_system_equal;
      },
      async set(value) {
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_TO_DIVIDE', null);
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_EQUAL', value);
        await this.$store.dispatch('cart/refreshCart');
        this.forceUpdateSummarySystem();
      },
    },
    amountSystemToDivide: {
      get() {
        return this.$store.state.cart.bet._system_detail.amount_system_to_divide;
      },
      async set(value) {
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_EQUAL', null);
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_TO_DIVIDE', value);
        await this.$store.dispatch('cart/refreshCart');
        this.forceUpdateSummarySystem();
      },
    },
  },
  watch: {
    showCustomKeyboard(val) {
      if (!val) {
        if (this.activeCombo) {
          const isEmpty = (v) => v === '' || v === null || v === undefined;
          if (isEmpty(this.activeCombo.amount)) {
            this.activeCombo.amount = this.previousAmount || 0;
          }
            this.refreshSystemCart(this.activeCombo);
          this.activeCombo = null;
        }
        if (this.activeGlobalField) {
          // no-op, min amount not enforced on global fields
        }
        this.activeGlobalField = null;
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById("modal_cart_content");
          if (!el) return;
          el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        }, 150);
      });
    },
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart',
      setSystemComboDetail: 'cart/setSystemComboDetail',
      setSystemAmountEqual: 'cart/setSystemAmountEqual',
      setSystemAmountToDivide: 'cart/setSystemAmountToDivide',
    }),
    forceUpdateSummarySystem() {
      this.$forceUpdate();
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    openKeyboard(combo) {
      this.activeCombo = combo;
      this.previousAmount = combo.amount || 0;
      combo.amount = '';
      this.showCustomKeyboard = true;
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(10);
    },
    openKeyboardGlobal(field) {
      this.activeCombo = null;
      this.activeGlobalField = field;
      const current = field === 'equal' ? this.amountSystemEqual : this.amountSystemToDivide;
      this.previousAmount = current || 0;
      if (field === 'equal') {
        this.$store.commit('cart/SET_SYSTEM_AMOUNT_EQUAL', '');
      } else {
        this.$store.commit('cart/SET_SYSTEM_AMOUNT_TO_DIVIDE', '');
      }
      this.showCustomKeyboard = true;
    },
    pressKey(key) {
      if (this.activeGlobalField) {
        const storeKey = this.activeGlobalField === 'equal'
            ? 'cart/SET_SYSTEM_AMOUNT_EQUAL'
            : 'cart/SET_SYSTEM_AMOUNT_TO_DIVIDE';
        const current = this.activeGlobalField === 'equal'
            ? this.$store.state.cart.bet._system_detail.amount_system_equal
            : this.$store.state.cart.bet._system_detail.amount_system_to_divide;
        let cur = String(current ?? '');
        if (cur === '' && key === 0) return;
        if (cur === '0' && key !== '.') cur = '';
        if (key === '.' && cur.includes('.')) return;
        if (key === '.' && cur === '') cur = '0';
        if (cur.includes('.') && cur.split('.')[1]?.length >= 2) {
          if (key === '.') return;
          if (cur.indexOf('.') !== -1 && cur.length - cur.indexOf('.') > 2) return;
        }
        cur += key;
        cur = cur.replace(/^0+([1-9])/, '$1').replace(/\.+/g, '.');
        const val = cur.endsWith('.') ? cur : Number(cur);
        if (this.activeGlobalField === 'equal') {
          this.amountSystemEqual = val;
        } else {
          this.amountSystemToDivide = val;
        }
        this.vibrate();
        return;
      }
      if (!this.activeCombo) return;
      let cur = String(this.activeCombo.amount ?? '');
      if (cur === '' && key === 0) return;
      if (cur === '0' && key !== '.') cur = '';
      if (key === '.' && cur.includes('.')) return;
      if (key === '.' && cur === '') cur = '0';
      if (cur.includes('.') && cur.split('.')[1]?.length >= 2) {
        if (key === '.') return;
        if (cur.indexOf('.') !== -1 && cur.length - cur.indexOf('.') > 2) return;
      }
      cur += key;
      cur = cur.replace(/^0+([1-9])/, '$1').replace(/\.+/g, '.');
      this.activeCombo.amount = cur.endsWith('.') ? cur : Number(cur);
      this.refreshSystemCart(this.activeCombo, false);
      this.vibrate();
    },
    backspace() {
      if (this.activeGlobalField) {
        const current = this.activeGlobalField === 'equal'
            ? this.$store.state.cart.bet._system_detail.amount_system_equal
            : this.$store.state.cart.bet._system_detail.amount_system_to_divide;
        let cur = String(current ?? '').slice(0, -1);
        const val = (cur === '' || cur === '0') ? 0 : cur.endsWith('.') ? cur : Number(cur);
        if (this.activeGlobalField === 'equal') {
          this.amountSystemEqual = val;
        } else {
          this.amountSystemToDivide = val;
        }
        return;
      }
      if (!this.activeCombo) return;
      let cur = String(this.activeCombo.amount ?? '').slice(0, -1);
      this.activeCombo.amount = (cur === '' || cur === '0') ? 0 : cur.endsWith('.') ? cur : Number(cur);
      this.refreshSystemCart(this.activeCombo);
    },
    stepCombo(combo, direction) {
      const current = parseFloat(combo.amount) || 0;
      const next = Math.max(0, Math.round((current + direction * 0.10) * 100) / 100);
      combo.amount = next;
      this.refreshSystemCart(combo);
    },
    stepGlobal(field, direction) {
      const current = field === 'equal'
          ? parseFloat(this.amountSystemEqual) || 0
          : parseFloat(this.amountSystemToDivide) || 0;
      const next = Math.max(0, Math.round((current + direction * 0.50) * 100) / 100);
      if (field === 'equal') {
        this.amountSystemEqual = next;
      } else {
        this.amountSystemToDivide = next;
      }
    },
    async refreshSystemCart(combo = undefined) {
      if (combo != undefined) {
        this.getBet._system_detail.amount_system_equal = null;
        this.getBet._system_detail.amount_system_to_divide = null;
        combo.checked = combo.amount > 0.00;
      }
      this.setCheckedAll();
      await this.setSystemComboDetail({ system_parts: this.getBet.system_parts });
      await this.refreshCart();
      this.forceUpdateSummarySystem();
    },
    async checkAllComboSystem() {
      if (this.checkedAll) {
        _.forEach(this.getBet.system_parts, (detail) => {
          if (detail != undefined && detail.valid_combinations > 0) detail.checked = true;
        });
      } else {
        _.forEach(this.getBet.system_parts, (detail) => {
          if (detail != undefined) detail.checked = false;
        });
      }
      await this.refreshSystemCart();
    },
    setCheckedAll() {
      const not_checked = _.filter(this.getBet.system_parts, (o) => {
        return o.checked == false && o.valid_combinations > 0;
      });
      this.checkedAll = !(not_checked == undefined || not_checked.length >= 1 || this.getBet._system_detail.valid_combinations_all == 0);
    },
    showDetailCombo(combo) {
      combo.show = !combo.show;
    },
    onComboCheckChange(combo) {
      if (!combo.checked) {
        combo.amount = 0;
      }
      this.refreshSystemCart();
    },

    // Handlers per tastierino nativo (mobile, mobileKeypadType === 'native')
    onNativeInputGlobal(field, e) {
      let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
      const parts = val.split('.');
      if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
      if (val.includes('.') && val.split('.')[1].length > 2) val = val.substring(0, val.indexOf('.') + 3);
      const num = val.endsWith('.') ? val : Number(val);
      if (field === 'equal') {
        this.amountSystemEqual = num;
      } else {
        this.amountSystemToDivide = num;
      }
    },
    onNativeBlurGlobal(field) {
    },
    onNativeInputCombo(combo, e) {
      let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
      const parts = val.split('.');
      if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
      if (val.includes('.') && val.split('.')[1].length > 2) val = val.substring(0, val.indexOf('.') + 3);
      combo.amount = val.endsWith('.') ? val : Number(val);
      this.refreshSystemCart(combo);
    },
    onNativeBlurCombo(combo) {
      this.refreshSystemCart(combo);
    },
  },
};
</script>

<style scoped>
.summary {
  padding: 0 0 2px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.summary-card {
  background: var(--bg-card);
  border-radius: 6px;
  padding: 6px;
}

/* --- Riga Superiore --- */
.summary-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.summary-title {
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-xl);
  text-transform: capitalize;
}

.summary-odds-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.odds-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
  text-transform: capitalize;
}

.odds-value {
  color: var(--color-primary-light);
  font-weight: 700;
  font-size: var(--font-size-3xl);
}


/* --- Global Amount Inputs --- */
.global-amounts-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 6px;
}

.global-amount-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.global-amount-label {
  flex: 0 0 45%;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-md);
  text-transform: capitalize;
}

.global-amount-label.evidence {
  color: var(--text-platform);
  font-weight: 600;
  font-size: var(--font-size-xl);
}

.global-input-group {
  flex: 1;
}

/* --- Lista Combinazioni (Combo table) --- */
.combo_container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-combo {
  display: flex;
  flex-direction: column;
  padding: 6px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.item-combo:hover {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
}

/* --- Check All Header --- */
.combo-header-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  padding: 0;
}

/* --- Checkbox custom --- */
.combo-check-label {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
}

.combo-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.combo-check-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 3px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  transition: border-color 0.15s, background 0.15s;
  flex-shrink: 0;
}

.combo-checkbox:checked + .combo-check-custom {
  background: var(--color-primary-light);
  border-color: var(--color-primary-light);
}

.combo-checkbox:checked + .combo-check-custom::after {
  content: '';
  display: block;
  width: 3px;
  height: 5px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) translate(-1px, -1px);
}

.combo-checkbox:disabled + .combo-check-custom {
  opacity: 0.3;
  cursor: not-allowed;
}

.combo-check-text {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-md);
  font-weight: 600;
  text-transform: capitalize;
}

.combo-row-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
}
.combo-row-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
}

.combo-title {
  flex: 1;
  color: var(--text-platform);
  font-weight: 600;
  font-size: var(--font-size-xl);
}

.combo-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

/* --- Input Group (simile a Singola/Integrale) --- */
.input-group {
  display: flex;
  background: var(--sidebar);
  overflow: hidden;
  gap: 3px;
  padding: 4px;
  border-radius: 6px;
  width: 100%;
}

.combo-multiplier {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px 0 2px;
  color: var(--text-op-50-platform);
  font-weight: 700;
  font-size: var(--font-size-md);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  margin-right: 2px;
}

.btn-stepper, .step-btn {
  background: var(--bg-card);
  color: var(--text-platform);
  height: 24px;
  width: 24px;
  font-size: var(--font-size-4xl);
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: none;
  flex-shrink: 0;
}

.btn-stepper:hover:not(:disabled), .step-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.05);
}

.btn-stepper:active:not(:disabled), .step-btn:active:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
}

.btn-stepper:disabled, .step-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.amount-input {
  flex: 1;
  width: 100%;
  background: var(--bg-card);
  border: none;
  color: var(--text-platform);
  font-size: var(--font-size-xl);
  font-weight: 600;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
  border-radius: 5px;
  padding: 0;
}

.amount-input:disabled {
  opacity: 0.5;
}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* --- Chevron Accordion --- */
.chevron-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 100%;
  cursor: pointer;
}

.combo-chevron {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-right: 2px solid var(--text-op-50-platform);
  border-bottom: 2px solid var(--text-op-50-platform);
  transform: rotate(45deg);
  transition: transform 0.25s ease;
}

.combo-chevron--open {
  transform: rotate(225deg);
  border-color: var(--color-primary-light);
}

/* --- Accordion Details --- */
.combo-accordion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  width: 100%;
  overflow: hidden;
  transition: grid-template-rows 0.25s ease;
}

.combo-accordion-wrapper--open {
  grid-template-rows: 1fr;
  margin-top: 6px;
}

.detail-system {
  min-height: 0;
  overflow: hidden;
  display: flex;
  width: 100%;
  background: rgba(0,0,0,0.15);
  border-radius: 5px;
  padding: 0 4px;
  gap: 6px;
}

.combo-accordion-wrapper--open .detail-system {
  padding: 4px;
}

.detail-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.detail-col:last-child {
  border-right: none;
}

.detail-label {
  font-size: var(--font-size-xs);
  color: var(--text-op-50-platform);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.detail-val {
  font-size: var(--font-size-md);
  color: var(--text-platform);
  font-weight: 700;
}


/* --- Extra Info Specifiche (Uniformate) --- */
.extra-info-container {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.extra-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-md);
}
.info-value {
  color: var(--color-primary-light);
  font-weight: 600;
  font-size: var(--font-size-xl);
}


/* --- Tastierino Mobile --- */
.keyboard-accordion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 0.1s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.keyboard-accordion-wrapper.keyboard-open {
  grid-template-rows: 1fr;
  opacity: 1;
}
.custom-keyboard-accordion {
  overflow: hidden;
  margin-top: 0;
  padding: 0 4px;
  background: var(--bg-card);
  border-radius: 6px;
  user-select: none;
  touch-action: none;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.keyboard-accordion-wrapper.keyboard-open .custom-keyboard-accordion {
  padding: 8px 0 0;
  margin-top: 8px;
}
.keyboard-row {
  display: flex;
  justify-content: space-between;
  gap: 3px;
  margin: 4px 0;
}
.keyboard-row button {
  flex: 1;
  padding: 6px 0;
  font-size: var(--font-size-5xl);
  background: var(--sidebar);
  border: none;
  border-radius: 5px;
  font-weight: 600;
  color: var(--text-platform);
  outline: none;
  transition: background 0.15s;
}
.keyboard-row button:active {
  background: #3c4652;
}
.close-keyboard {
  width: 100%;
  padding: 8px 0;
  background: #ef4444 !important;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  font-size: var(--font-size-2xl);
}
</style>